import React from 'react';
import {Col, Flex} from "antd";
import { SpecificationsPopUPCardProps} from "../../../models";
import {StyledCard} from "./SpecificationsPopUp.styled";
import style from "./SpecificationsPopUp.module.scss";
import {IoShieldCheckmark} from "react-icons/io5";

const SpecificationsPopUPCard = ({title,description }: SpecificationsPopUPCardProps) => {

    return (
        <Flex justify={"space-around"} align={"baseline"}>
            <Col xs={8} sm={8} md={8} lg={8} xl={8}>

            <Flex gap={"small"}>
                <span className={style.greyFont}>{title} </span>
            </Flex>
            </Col>
                <Col xs={15} sm={15} md={15} lg={15} xl={15}>

                <Flex gap={"small"} style={{textAlign:"justify" ,fontSize:"13px"}}>
                <span>{description}</span>
            </Flex>
                </Col>
        </Flex>
    );
};

export default SpecificationsPopUPCard;
